<div class="public-layout-container">
    @if (showHeader()) {
        <app-public-header></app-public-header>
    }
    <main class="public-layout-content">
        <router-outlet></router-outlet>
    </main>
    <app-footer></app-footer>
</div>